export const formatDateTo12HourTime = (date) => {
  const newDate = new Date(date)
  if (Number.isNaN(newDate.getTime())) return "Invalid time"

  let hours = newDate.getHours()
  let mins = newDate.getMinutes()
  const suffix = hours >= 12 ? "PM" : "AM"
  if (hours > 12) {
    hours -= 12
  } else if (hours === 0) {
    hours = 12
  }
  if (mins < 10) {
    mins = `0${mins}`
  }
  return `${hours}:${mins} ${suffix}`
}
